var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHooli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_161",
    "data-name": "Rect\\xE1ngulo 161",
    width: 34,
    height: 34,
    transform: "translate(-0.306)",
    fill: "#5567ae",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ojos_Hooli",
    "data-name": "Ojos Hooli",
    d: "M20.258,18.227A8.983,8.983,0,0,1,17.2,16.148q-.1-.1-.195-.209-.095.106-.193.209a8.926,8.926,0,0,1-3.043,2.079A10.51,10.51,0,0,1,9.712,19a10.55,10.55,0,0,1-4.065-.773,8.984,8.984,0,0,1-3.055-2.079A9.114,9.114,0,0,1,.668,13.125,9.885,9.885,0,0,1,0,9.517,9.537,9.537,0,0,1,2.6,2.843,8.986,8.986,0,0,1,5.662.769,10.54,10.54,0,0,1,9.712,0a10.5,10.5,0,0,1,4.044.769A8.929,8.929,0,0,1,16.8,2.843q.105.11.207.223.1-.113.208-.223A8.987,8.987,0,0,1,20.273.769a11.04,11.04,0,0,1,8.1,0,8.925,8.925,0,0,1,3.045,2.074A9.562,9.562,0,0,1,34,9.517a9.517,9.517,0,0,1-2.574,6.631,8.922,8.922,0,0,1-3.043,2.079,11.059,11.059,0,0,1-8.125,0Zm-.773-8.709c0,3.132,2.08,5.493,4.838,5.493s4.838-2.377,4.838-5.528c0-3.132-2.08-5.493-4.838-5.493S19.485,6.366,19.485,9.517Zm-14.612,0c0,3.132,2.08,5.493,4.838,5.493s4.838-2.377,4.838-5.528c0-3.132-2.08-5.493-4.838-5.493S4.874,6.366,4.874,9.517ZM22.479,9.5a1.827,1.827,0,1,1,1.826,1.79A1.808,1.808,0,0,1,22.479,9.5ZM7.868,9.5a1.827,1.827,0,1,1,1.827,1.79A1.809,1.809,0,0,1,7.868,9.5Z",
    transform: "translate(-0.306 8)",
    fill: "#5567ae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHooli);
export default __webpack_public_path__ + "static/media/hooli.bc76ca50f5a017f568739ac8554e9f16.svg";
export { ForwardRef as ReactComponent };